import React from 'react';
import { PencilIcon, TrashIcon, MapPinIcon, PhoneIcon, GlobeAltIcon } from '@heroicons/react/24/outline';

const BranchCard = ({ branch, onEdit, onDelete, onStatusToggle }) => {
    return (
        <div className="bg-white rounded-2xl shadow-sm border border-slate-100 overflow-hidden hover:shadow-md transition-all group">
            <div className={`h-2 bg-gradient-to-r ${branch.is_active ? 'from-primary-500 to-primary-600' : 'from-slate-300 to-slate-400'}`}></div>

            <div className="p-5">
                <div className="flex items-start justify-between mb-4">
                    <div className={`p-3 rounded-xl bg-gradient-to-br ${branch.is_active ? 'from-primary-500 to-primary-600' : 'from-slate-400 to-slate-500'} text-white shadow-sm`}>
                        <MapPinIcon className="h-6 w-6" />
                    </div>
                    <div className="flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
                        <button
                            onClick={() => onEdit(branch)}
                            className="p-2 hover:bg-slate-50 rounded-lg text-slate-400 hover:text-primary-600 transition-colors"
                            title="Edit"
                        >
                            <PencilIcon className="h-5 w-5" />
                        </button>
                        <button
                            onClick={() => onDelete(branch.id)}
                            className="p-2 hover:bg-slate-50 rounded-lg text-slate-400 hover:text-red-600 transition-colors"
                            title="Delete"
                        >
                            <TrashIcon className="h-5 w-5" />
                        </button>
                    </div>
                </div>

                <div className="space-y-3">
                    <div className="flex items-center justify-between">
                        <button
                            onClick={() => onStatusToggle(branch.id, !branch.is_active)}
                            className={`text-[10px] font-bold px-2 py-0.5 rounded-full uppercase tracking-wider transition-colors ${branch.is_active ? 'bg-green-50 text-green-600 hover:bg-green-100' : 'bg-slate-100 text-slate-500 hover:bg-slate-200'}`}
                        >
                            {branch.is_active ? 'Active' : 'Inactive'}
                        </button>
                        <span className="text-[10px] font-bold text-slate-400">ORDER #{branch.display_order}</span>
                    </div>

                    <div>
                        <h3 className="text-slate-900 font-bold text-lg leading-tight group-hover:text-primary-600 transition-colors">
                            {branch.name}
                        </h3>
                        <p className="text-slate-500 text-sm font-medium">{branch.city}, {branch.state}</p>
                    </div>

                    <div className="space-y-2 border-t border-slate-50 pt-3">
                        <div className="flex items-start gap-2 text-xs text-slate-600">
                            <MapPinIcon className="h-4 w-4 text-slate-400 flex-shrink-0" />
                            <span className="line-clamp-2">{branch.address}</span>
                        </div>
                        <div className="flex items-center gap-2 text-xs text-slate-600">
                            <PhoneIcon className="h-4 w-4 text-slate-400 flex-shrink-0" />
                            <span>{branch.contact}</span>
                        </div>
                    </div>

                    <div className="flex gap-2 pt-1">
                        {branch.map_link && (
                            <a href={branch.map_link} target="_blank" rel="noopener noreferrer" className="flex-1 flex items-center justify-center gap-1.5 py-1.5 px-2 bg-slate-50 hover:bg-slate-100 text-slate-600 text-[10px] font-bold rounded-lg transition-colors">
                                <GlobeAltIcon className="h-3 w-3" />
                                MAPS
                            </a>
                        )}
                        {branch.review_link && (
                            <a href={branch.review_link} target="_blank" rel="noopener noreferrer" className="flex-1 flex items-center justify-center gap-1.5 py-1.5 px-2 bg-slate-50 hover:bg-slate-100 text-slate-600 text-[10px] font-bold rounded-lg transition-colors">
                                <StarIcon className="h-3 w-3" />
                                REVIEWS
                            </a>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

// Simple StarIcon for reviews if not imported from HeroIcons
const StarIcon = ({ className }) => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className={className}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M11.48 3.499a.562.562 0 0 1 1.04 0l2.125 5.111a.563.563 0 0 0 .475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 0 0-.182.557l1.285 5.385a.562.562 0 0 1-.84.61l-4.725-2.885a.562.562 0 0 0-.586 0L6.982 20.54a.562.562 0 0 1-.84-.61l1.285-5.386a.562.562 0 0 0-.182-.557l-4.204-3.602a.562.562 0 0 1 .321-.988l5.518-.442a.563.563 0 0 0 .475-.345L11.48 3.5Z" />
    </svg>
);

export default BranchCard;
